import { format } from 'date-fns';

export function formatDateFromNumber(endDate: number): string {
    const date = new Date(endDate * 1000);

    const formatedDate = format(date, 'dd.MM.yy');

    return formatedDate;
}

// export function calculateDaysPassedAndTotal(endLockDate: number, weight: number, depositedAmount: number): [number, number] {
//     const multiplier = weight / depositedAmount;

//     let lockupMonths = 0;

//     if (multiplier === 1) {
//         lockupMonths = 3;
//     } else if (multiplier === 1.5) {
//         lockupMonths = 6;
//     } else if (multiplier === 2) {
//         lockupMonths = 12;
//     } else {
//         return [0, 0];
//         // throw new Error('Invalid multiplier');
//     }

//     const totalDays = Math.round(lockupMonths * 30);

//     const endDate = new Date(endLockDate * 1000);
//     const startDate = new Date(endDate);
//     startDate.setMonth(startDate.getMonth() - lockupMonths);

//     const now = new Date();
//     const timePassed = now.getTime() - startDate.getTime();

//     const daysPassed = Math.floor(timePassed / (1000 * 60 * 60 * 24));

//     const validDaysPassed = daysPassed < 0 ? 0 : daysPassed > totalDays ? totalDays : daysPassed;

//     return [validDaysPassed, totalDays];
// }

export function calculateDaysPassedAndTotal(endLockDate: number, weight: number, depositedAmount: number): [number, number] {
    const multiplier = Math.round((weight / depositedAmount) * 100) / 100;
    let lockupMonths = 0;

    if (multiplier === 1) {
        lockupMonths = 3;
    } else if (multiplier === 1.5) {
        lockupMonths = 6;
    } else if (multiplier === 2) {
        lockupMonths = 12;
    } else {
        return [0, 0];
    }

    // Общее количество дней, считая, что месяц = 30 дней
    const totalDays = lockupMonths * 30;

    // Дата окончания блокировки
    const endDate = new Date(endLockDate * 1000);

    // Дата начала блокировки (на 30 * lockupMonths дней назад)
    const startDate = new Date(endDate.getTime() - totalDays * 24 * 60 * 60 * 1000);

    // Текущая дата
    const now = new Date();

    // Прошло дней с начала блокировки, считая фиксированные 30 дней в месяце
    const timePassed = now.getTime() - startDate.getTime();
    const daysPassed = Math.floor(timePassed / (1000 * 60 * 60 * 24));

    // Ограничиваем корректный диапазон
    const validDaysPassed = Math.max(0, Math.min(daysPassed, totalDays));

    return [validDaysPassed, totalDays];
}

export function getDeltaOfDate(endLockDate: number, weight: number, depositedAmount: number): string {
    const multiplier = weight / depositedAmount;

    let lockupMonths = 0;

    if (multiplier === 1) {
        lockupMonths = 3;
    } else if (multiplier === 1.5) {
        lockupMonths = 6;
    } else if (multiplier === 2) {
        lockupMonths = 12;
    } else {
        return '-';
        // throw new Error('Invalid multiplier');
    }

    const endDate = new Date(endLockDate * 1000);

    const startDate = new Date(endDate);
    startDate.setMonth(startDate.getMonth() - lockupMonths);

    return `${format(startDate, 'dd.MM.yy')} - ${format(endDate, 'dd.MM.yy')}`;
}
